import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CodeBlock = ({ code, language, title, showCopy = true }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  const getLanguageColor = (lang) => {
    const colors = {
      javascript: 'text-yellow-600',
      python: 'text-blue-600',
      php: 'text-purple-600',
      bash: 'text-green-600',
      json: 'text-orange-600',
      curl: 'text-gray-600'
    };
    return colors[lang] || 'text-gray-600';
  };

  return (
    <div className="bg-gray-900 rounded-lg overflow-hidden">
      {title && (
        <div className="flex items-center justify-between px-4 py-2 bg-gray-800 border-b border-gray-700">
          <div className="flex items-center space-x-2">
            <Icon name="Code" size={16} className="text-gray-400" />
            <span className="text-sm font-medium text-gray-200">{title}</span>
            {language && (
              <span className={`text-xs px-2 py-1 rounded ${getLanguageColor(language)} bg-gray-700`}>
                {language.toUpperCase()}
              </span>
            )}
          </div>
          {showCopy && (
            <Button
              variant="ghost"
              size="sm"
              onClick={handleCopy}
              iconName={copied ? "Check" : "Copy"}
              iconSize={14}
              className="text-gray-400 hover:text-gray-200"
            >
              {copied ? 'Copied!' : 'Copy'}
            </Button>
          )}
        </div>
      )}
      
      <div className="p-4 overflow-x-auto">
        <pre className="text-sm text-gray-300 font-mono leading-relaxed">
          <code>{code}</code>
        </pre>
      </div>
    </div>
  );
};

export default CodeBlock;